<script>
import { TEMPLATE_ID_PROP } from './constants';
export default {
  name: 'DefaultFallbackComponent',
  props: {
    metadata: { type: Object },
    data: { type: Object }
  },
  computed: {
    templateId() {
      return this.metadata[TEMPLATE_ID_PROP];
    }
  },
  methods: {
    trimIfObject(value) {
      if (value === '[object Object]') {
        return '[object]';
      }
      return value;
    },
    formatValue(value) {
      return this.trimIfObject('' + value);
    }
  }
};
</script>
<template>
  <div>
    <div>
      <strong>
        <em>Template not found: {{ templateId }}</em>
      </strong>
    </div>
    <div v-for="(value, key) in data" :key="key">{{ key }}: {{ formatValue(value) }}</div>
    <p />
  </div>
</template>
